import {
  BankOutlined,
  DashboardOutlined,
  EditOutlined,
  FileImageOutlined,
  SettingOutlined,
  SmileOutlined,
  TeamOutlined,
  TransactionOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

export const menuItems = [
  {
    key: "1",
    pathname: "/",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },

  {
    key: "2",
    icon: <TeamOutlined />,
    label: "Operator",
    permissions: [
      "AGENT_READ_OPERATOR",
      "AGENT_CREATE_OPERATOR",
      "AGENT_UPDATE_OPERATOR",
      "AGENT_DELETE_OPERATOR",
      "AGENT_READ_PERMISSION",
    ],
    children: [
      {
        key: "2.1",
        pathname: "/operator",
        icon: <UnorderedListOutlined />,
        label: "Opeator list",
        permissions: ["AGENT_READ_OPERATOR"],
      },
    ],
  },
  {
    key: "3",
    pathname: "/agent_bank",
    icon: <BankOutlined />,
    label: "Bank",
    permissions: ["AGENT_READ_BANK_ACCOUNT"],
  },
  {
    key: "4",
    pathname: "/user",
    icon: <TeamOutlined />,
    label: "User",
    permissions: ["AGENT_READ_USER"],
  },
  {
    key : "5",
    pathname : "/transaction",
    icon : <TransactionOutlined />,
    label : "Transaction",
    permissions : ["AGENT_READ_USER_TRANSACTION"],
    showBadge : true,
  },
  {
    key : "6",
    pathname : "/social",
    icon : <FileImageOutlined />,
    label : "Social",
    permissions : ["AGENT_READ_SOCIAL"]
  },

  {
    key: "7",
    pathname: "/avatar",
    icon: <SmileOutlined />,
    label: "Avatar",
    permissions: ["AGENT_READ_AVATAR"],
  },
  // {
  //   key: "8",
  //   pathname: "/ui",
  //   icon: <EditOutlined />,
  //   label: "Edit UI",
  //   permissions: ["AGENT_UPDATE_UI"],
  // },
  {
    key: "9",
    pathname: "/setting",
    icon: <SettingOutlined />,
    label: "Setting",
  },
];
